<template>
  <div>
    <v-row>
      <v-col cols='12'>
        <v-text-field
          label='Division name'
          :rules='[rules.required]'
          v-model='value.division'
        ></v-text-field>
      </v-col>
      <v-col cols='12'>
        <v-text-field
          label='Company Name'
          :rules='[rules.required]'
          v-model='value.company_name'
        ></v-text-field>
      </v-col>
      <v-col cols='12'>
        <v-text-field
          label='GST Number'
          v-model='value.gst_number'
        ></v-text-field>
      </v-col>
      <v-col cols='12' md='4'>
        <v-text-field
          label='Order'
          v-model='value.order'
        ></v-text-field>
      </v-col>
      <v-col cols='12' md='4'>
        <v-text-field
          label='Icon'
          v-model='value.icon'
        ></v-text-field>
      </v-col>
      <v-col cols='12' md='4'>
        <wc-colorpicker
          label='Icon color'
          v-model='value.icon_color'
        ></wc-colorpicker>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import formRules from '@/mixins/formRules'

export default {
  name: 'division-basics-form',
  mixins: [formRules],
  props: {
    value: {
      required: true
    }
  }
}
</script>
